'use client';
import { type FC, useEffect } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import useLocalStorage from '@/hooks/useLocalstorage';
import { Icon, type IconProps } from '@/components/elements/Icon';

export const MonetaryVisibilityButton: FC<MonetaryVisibilityButtonProps> = ({
  iconProps,
  widgetId = null,
  ...props
}) => {
  const [isVisible, setIsVisible] = useLocalStorage(
    'monetary-values-visibility',
    false
  );

  const toggleVisibility = () => {
    if (isVisible) hideMonetaryValues(widgetId);
    else showMonetaryValues(widgetId);
    setIsVisible(!isVisible);
  };

  const recheckVisibility = () => {
    const isVisible =
      localStorage.getItem('monetary-values-visibility') === 'true' || false;
    if (isVisible) return showMonetaryValues(widgetId);
    hideMonetaryValues(widgetId);
  };

  useEffect(() => {
    window.addEventListener('recheck-monetary-visibility', recheckVisibility);
    return () => {
      window.removeEventListener(
        'recheck-monetary-visibility',
        recheckVisibility
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      aria-label={`${isVisible ? 'Esconder' : 'Mostrar'} valores`}
      data-testid="monetary-visibility-button"
      onClick={toggleVisibility}
      cursor="pointer"
      {...props}
    >
      <Icon
        iconName={!isVisible ? 'ViewOff' : 'View'}
        w={24}
        h={24}
        color="content.primary"
        {...iconProps}
      />
    </Box>
  );
};

const showMonetaryValues = (widgetId: string | null) => {
  const centerElements = document.querySelectorAll(
    checkAppendWidgetIdInSelector('.hide-monetary-center', widgetId)
  );
  const leftElements = document.querySelectorAll(
    checkAppendWidgetIdInSelector('.hide-monetary-left', widgetId)
  );
  const rightElements = document.querySelectorAll(
    checkAppendWidgetIdInSelector('.hide-monetary-right', widgetId)
  );
  centerElements.forEach((e) => {
    e.classList.remove('hide-monetary-center');
    e.classList.add('show-monetary-center');
  });
  leftElements.forEach((e) => {
    e.classList.remove('hide-monetary-left');
    e.classList.add('show-monetary-left');
  });
  rightElements.forEach((e) => {
    e.classList.remove('hide-monetary-right');
    e.classList.add('show-monetary-right');
  });
};

const hideMonetaryValues = (widgetId: string | null) => {
  const centerElements = Array.from(
    document.querySelectorAll(
      checkAppendWidgetIdInSelector('.show-monetary-center', widgetId)
    )
  );
  const leftElements = Array.from(
    document.querySelectorAll(
      checkAppendWidgetIdInSelector('.show-monetary-left', widgetId)
    )
  );
  const rightElements = Array.from(
    document.querySelectorAll(
      checkAppendWidgetIdInSelector('.show-monetary-right', widgetId)
    )
  );
  centerElements.forEach((e) => {
    e.classList.remove('show-monetary-center');
    e.classList.add('hide-monetary-center');
  });
  leftElements.forEach((e) => {
    e.classList.remove('show-monetary-left');
    e.classList.add('hide-monetary-left');
  });
  rightElements.forEach((e) => {
    e.classList.remove('show-monetary-right');
    e.classList.add('hide-monetary-right');
  });
};

const checkAppendWidgetIdInSelector = (
  selector: string,
  widget_id: string | null
) => {
  return widget_id ? `#${widget_id} ${selector}` : selector;
};

type MonetaryVisibilityButtonProps = {
  iconProps?: IconProps;
  widgetId?: string;
} & BoxProps;
